import { useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { actionBarAtom } from 'common/actionBar/stores/atom';
import { Drawer, Stack, useMediaQuery } from '@mui/material';
import { ActionBarInputs } from 'common/actionBar/types/actionBar';
import { useActionBar } from 'common/actionBar/hooks/useActionBar';
import { useActionBarHeight } from 'common/actionBar/hooks/useActionBarHeight';

const ActionBarContent: React.FC<{
  inputs: ActionBarInputs;
}> = ({ inputs }) => {
  const alignment = inputs.align ?? 'right';
  return (
    <Stack
      direction="row"
      sx={{
        py: '20px',
        px: '48px',
        justifyContent: alignment === 'left' ? 'flex-start' : 'flex-end'
      }}
    >
      {inputs.children}
    </Stack>
  );
};

export const ActionBar = () => {
  const actionBar = useRecoilValue(actionBarAtom);
  const { closeActionBar } = useActionBar();
  const paperRef = useRef<HTMLDivElement>(null);

  const prefersReducedMotion = useMediaQuery(
    '(prefers-reduced-motion: reduce)'
  );

  const { isOpen, inputs } = actionBar;

  useActionBarHeight(paperRef, isOpen);

  return (
    <Drawer
      open={isOpen}
      anchor="bottom"
      variant="persistent"
      onClose={() => closeActionBar()}
      PaperProps={{ ref: paperRef }}
      transitionDuration={prefersReducedMotion ? 0 : undefined}
    >
      {inputs && <ActionBarContent inputs={inputs} />}
    </Drawer>
  );
};
